import React from 'react';
import { useStaticQuery, graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const BblTwoColumnWrapperBlock = (props) => {

    const data = useStaticQuery(graphql`
        query twoColumnWrapperOverrides {
            wp {
                themeOptions {
                    ThemeOptions {
                        twoColumnWrapper {
                            backgroundColour
                        }
                    }
                }
            }
        }`);

    let overrides = data.wp.themeOptions.ThemeOptions.twoColumnWrapper;

    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={` ${props.attributes.className ? props.attributes.className : ''} ${classes.twoColumnWrapper} `}
                data-override-background={overrides.backgroundColour !== 'background' ? overrides.backgroundColour : null}
    >
        <div className="wrapper">
            {blocks.map((block) => {
                return block;
            })}
        </div>
    </div>
};

export const BblTwoColumnWrapperBlockFragment = graphql`
  fragment BblTwoColumnWrapperBlock on WpBlock {
    ... on WpBblTwoColumnWrapperBlock {
        name
        attributes {
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const BblTwoColumnWrapperBlockPreview = `
    ... on BblTwoColumnWrapperBlock {
        name
        attributes {
            className
        }
    }
`;